Flup.service("server", function (flup, config) {
   var that = this;
   /* URL ------------------------------------------- */
   var _path = config.path || "";
   var _isProd = config.prod;
   var _redirecting = false;

   function _isAbsoluteUrl(url) {
      return /^[a-z]+:\/\/.+$/i.test(url);
   }

   that.makeUrl = function (url) {
      if (_isAbsoluteUrl(url)) return url;
      if (_path && url.indexOf(_path) === 0) return url;
      if (url.indexOf("/") !== 0) url = "/" + url;
      return _path + url;
   }

   that.location = function (url) {
      _redirecting = true;
      window.location.href = that.makeUrl(url);
   }

   /* REQUEST ------------------------------------------- */
   var _defaults = {
      before: function (opt) {
         if(opt.loadingAlert){
            flup("alert").loading(opt.loadingMsg)
         }
         else if(opt.loadingFull){
            flup("loader").loadingFull();
         }
         else if(opt.$loadingElm){
            opt._loaderId = flup("loader").loading(opt.$loadingElm, !!opt.darkLoader);
         }
      },
      done: function (opt, res) {
         if (res.message) {
            flup("alert").message(res.message);
         } else if(opt.loadingAlert) {
            flup("alert").closeAll();
         }
      },
      fail: function (opt, res) {
         if (res.message) {
            flup("alert").message(res.message);
         } else {
            flup("alert").message({
               type: 'error',
               text: 'Lo sentimos, ha ocurrido un error inesperado. Intentalo nuevamente.',
               description: res.failText,
            })
         }
      },
      always: function (opt, res) {
         if (!opt.multiple) _requestRunning = false;
         if(opt.loadingFull){
            flup("loader").removeFull();
         }
         else if(opt.$loadingElm){
            flup("loader").remove(opt.$loadingElm, opt._loaderId);
         }
      },
   };

   var _requestRunning = false;
   function _getFormData(postData, postFiles) {
      var formData = new FormData();
      formData.append("data_json", JSON.stringify(postData || {}));
      postFiles = postFiles || {};
      for (var x in postFiles) {
         if (postFiles[x]) {
            if (Array.isArray(postFiles[x])) {
               $.each(postFiles[x], function (i, file) {
                  formData.append(x + '[]', file);
               });
            } else {
               formData.append(x, postFiles[x]);
            }
         }
      }
      return formData;
   }

   function _callRequestEvent(name, res, opt) {
      opt[name] && opt[name](opt, res);
      if (!opt.isDefaultPrevented()) {
         _defaults[name] && _defaults[name](opt, res);
      }
   }

   function _callAjax(opt) {
      var response = null;
      function filterResponse(res){
         res = res || {};
         res.data = res.data || {};
         return res;
      }

      $.ajax({
         url: that.makeUrl(opt.url),
         data: _getFormData(opt.data, opt.files),
         type: "POST",
         processData: false,
         contentType: false,
         dataType: "json"
      })
         .done(function (res) {
            if (_redirecting) return;
            if (!opt.multiple) _requestRunning = false;
            response = filterResponse(res);
            _callRequestEvent("done", response, opt);
            if (response.redirect) that.location(response.redirect);
         })
         .fail(function (failRes) {
            if (_redirecting) return;
            if (!opt.multiple) _requestRunning = false;
            response = filterResponse(failRes.responseJSON);
            response.failtText = _isProd ? "" : failRes.responseText;
            _callRequestEvent("fail", response, opt);
         })
         .always(function () {
            if (_redirecting) return;
            _callRequestEvent("always", response, opt);
         });
   }

   that.request = function (opt) {
      opt = $.extend({}, config.defaults||{}, opt);

      if (_redirecting) return;
      if (!opt.multiple) {
         if (_requestRunning) { return; } else { _requestRunning = true; }
      }

      var defaultPrevented = false;
      opt.isDefaultPrevented = function () { return defaultPrevented; }
      opt.preventDefault = function () { defaultPrevented = true; }

      _callRequestEvent("before", null, opt);

      if (opt.confirm) {
         flup("alert").confirm({
            text: opt.confirm,
            onAccept: function () { _callAjax(opt); },
            onCancel: function () { _defaults.always(opt); }
         });
      } else {
         _callAjax(opt);
      }
   }
});

Flup.click("request", function (flup, $elm, value, e) {
   e.preventDefault();
   var data = $elm.data("post");
   if(data) $elm.removeAttr("data-post");
   
   flup("server").request({
      url: value || $elm.attr("href"),
      data: data,
      $loadingElm: $elm,
      loadingFull: $elm.is("[data-loading-full]"),
      loadingAlert: $elm.is("[data-loading-alert]"),
      confirm: $elm.data("confirm"),
   });
});

Flup.click("location", function(flup, $elm, value, e){
   e.preventDefault();
   e.stopPropagation();
   if($elm.is("[data-loading-full]")){
      flup("loader").loadingFull();
   }
   flup("server").location(value);
});